<template>

    <div>
        <!-- 核销码 -->
        <div class='header-box'>
            <!-- <div class='shop-name'>兄弟龙虾</div> -->
            <img class='img' :src='row.url' >
            <div style="padding: 15px;">
                <van-button type="danger" round size="large">长按图片保存到手机</van-button>
            </div>
        </div>
        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>

</template>

<script>
    import LoginDialog from '@/components/LoginDialog.vue';
    import Vue from 'vue'
    import {
        Toast
    } from 'vant';

    Vue.use(Toast) ;
    export default {
        name: "PostDownload",
        components: {
            LoginDialog
        },
        data: function () {
            return {
                loginShow:false,
                goods_id: 0,
                row: {
                    filename: '',
                    url: '',
                },
            }
        },
        mounted(){
          document.title="海报下载"
           this.goods_id = this.$route.query.goods_id;
           this.fetch();
        },
        methods: {
            fetch() {

                let that = this;
                that.$api.get('/api/goods/posterImage', {
                    goods_id: that.goods_id,
                    needLoadingIndicator: true
                },(res) => {
                    that.row = res.data
                },(res) => {
                    Toast(res.msg)
                })
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch()
            },

            loginCancel(){
                console.log('-------取消登录--------');
                this.loginShow = false;
            },
        }
    }
</script>

<style scoped>
    .header-box {
        width: 353.5px;
        margin: 15px auto;
        background: rgba(255, 255, 255, 1);
        border-radius: 5px;
        text-align: center;
        color: #1c1c1c;
        font-size: 16px;
        padding: 15px 10px;
        box-sizing: border-box;
    }

    .header-box img {
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// PostDownload.vue?25d1da69